import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export function TestimonialSection() {
  return <section className="py-12 md:py-20 px-4 bg-forest-900 border-y border-forest-700" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <div className="text-center mb-8 md:mb-16" data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-4" data-id="element-209">
            Resultados Reales
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-210">
          {/* Doña Rosa */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-forest-800 p-5 md:p-8 rounded-2xl border border-forest-600 relative" data-id="element-211">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-8 h-8 md:w-10 md:h-10 text-forest-600 fill-current" data-id="element-212" />
            <div className="flex gap-1 mb-4" data-id="element-213">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-214" />)}
            </div>
            <p className="text-lg md:text-xl font-serif text-cream-200 italic mb-4 md:mb-6" data-id="element-215">
              "Llevo 40 años recomendando y usando estas mismas plantas del
              Mercado Sonora. La naturaleza no se equivoca si sabes cómo
              usarla."
            </p>
            <div className="flex items-center gap-4" data-id="element-216">
              <div className="w-12 h-12 bg-forest-600 rounded-full flex items-center justify-center text-gold-500 font-bold font-serif text-xl" data-id="element-217">
                R
              </div>
              <div data-id="element-218">
                <p className="font-bold text-cream-100" data-id="element-219">Doña Rosa</p>
                <p className="text-sm text-cream-300" data-id="element-220">
                  Yerbera experta, Mercado Sonora
                </p>
              </div>
            </div>
          </motion.div>

          {/* Juan CDMX */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-forest-800 p-5 md:p-8 rounded-2xl border border-gold-500/30 relative shadow-lg shadow-gold-500/5" data-id="element-221">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-8 h-8 md:w-10 md:h-10 text-gold-500/20 fill-current" data-id="element-222" />
            <div className="flex gap-1 mb-4" data-id="element-223">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-224" />)}
            </div>

            <div className="bg-forest-900/50 p-3 md:p-4 rounded-lg mb-4 md:mb-6 border border-forest-600" data-id="element-225">
              <div className="flex justify-between items-center mb-2" data-id="element-226">
                <span className="text-xs uppercase tracking-wider text-cream-300" data-id="element-227">
                  Antes
                </span>
                <span className="text-xs uppercase tracking-wider text-gold-400 font-bold" data-id="element-228">
                  Después (Semana 1)
                </span>
              </div>
              <div className="w-full bg-forest-700 h-2 rounded-full mb-1 overflow-hidden" data-id="element-229">
                <div className="bg-red-500/50 h-full w-[50%]" data-id="element-230" />
              </div>
              <div className="flex justify-between text-sm font-mono text-cream-200" data-id="element-231">
                <span data-id="element-232">4 horas</span>
                <span className="text-gold-400 font-bold" data-id="element-233">7.5 horas</span>
              </div>
            </div>

            <p className="text-lg md:text-xl font-serif text-cream-200 italic mb-4 md:mb-6" data-id="element-234">
              "Sin resaca, llego a la oficina nítido. Mis horas de sueño
              subieron y mis despertares bajaron a cero."
            </p>
            <div className="flex items-center gap-4" data-id="element-235">
              <div className="w-12 h-12 bg-forest-600 rounded-full flex items-center justify-center text-gold-500 font-bold font-serif text-xl" data-id="element-236">
                J
              </div>
              <div data-id="element-237">
                <p className="font-bold text-cream-100" data-id="element-238">Juan, 42 años</p>
                <p className="text-sm text-cream-300" data-id="element-239">
                  Auditor con estrés extremo, CDMX
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}